import { Career, CareersSingleJob } from './types';

export const normalizeJob = (raw: any): CareersSingleJob | Career => ({
  ...raw,
  categoryIds: [raw.category],
  locationIds: [raw.location.id],
  typeIds: [raw.jobtype.id],
});
